<div class="not-found">
    <h1>Данной страницы не существует</h1>
</div>
